import * as styles from './styles';
import { QRCodeSVG } from 'qrcode.react';
import { useSignInContext } from '@context/SignIn';
import { useEffect } from 'react';

const Content = () => {
  const { generateCode, tvCode, targetUrl } = useSignInContext();

  useEffect(() => {
    generateCode();
  }, []);

  return (
    <div>
      <p css={styles.title}>모바일에서 시작하세요</p>
      <div css={styles.content}>
        <QRCodeSVG css={styles.qr} value={targetUrl} />
        <div css={styles.instruction}>
          <p css={styles.commonInformation}>
            모바일에서 QR코드를 스캔해 웹페이지에 접속하고
            <br />
            아래 코드를 입력해 인증을 진행해 주세요.
          </p>
          <p css={styles.privacyInformation}>
            QR코드는 타인과 공유하지 않도록 유의해 주세요.
          </p>
          <p css={styles.qrNumber}>{tvCode}</p>
        </div>
      </div>
    </div>
  );
};

export default Content;
